import { RoleCode } from "../../utils/RolesPermissions";

export const RoutePutUsers_userId_ = "/users/:userId";

export interface PayloadPutUsers_userId_ {
  firstName?: string;
  lastName?: string;
  email?: string;
  roleCode?: RoleCode;
}

export interface ResponsePutUsers_userId_ {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  userType: "MERCHANT_USER";
  merchantId: number;
  roleCode: RoleCode;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
}

export const RouteDeleteUsers_userId_ = "/users/:userId";

export type ResponseDeleteUsers_userId_ = void;
